export class DateOnly extends Date {}
